import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
interface IexpireListProps {
  guid: string;
  label: string;
}
interface ExpireNotificationProps {
  expireList: Array<IexpireListProps>;
  type: string;
}
const ExpireNotification = ({expireList, type}: ExpireNotificationProps) => {
  const {guid} = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="bg-red-50 border-[1px] border-red-600 px-3 py-3 gap-1  rounded relative flex flex-col"
      role="alert"
    >
      <div className="flex w-full justify-between pb-2 ">
        <SpanIcon className="icon-namereport-2 text-xxl text-red-600" />
      </div>
      <h5 className="text-gray-900 text-sm font-Medium  m-0 p-0">
        غیر فعال شدن
      </h5>
      <p className="text-gray-900 text-sm font-Regular m-0 p-0">
        مدت زمان{' '}
        {expireList.map((item, index) => (
          <span
            key={index}
            className="text-red-600 text-sm font-Medium"
            onClick={() =>
              navigate(`/upgrade/${type}/account/${guid}`, {
                state: {selected: [item.guid]},
              })
            }
          >
            {item.label} {expireList.length - 1 !== index && ' و '}
          </span>
        ))}
        آگهی شما به اتمام رسیده است.
      </p>
      <div className="flex w-full justify-end pt-2">
        <button
          className="bg-red-600 text-white text-sm font-Regular py-1 px-2 rounded-[8px]"
          onClick={() => {
            navigate(`/upgrade/${type}/account/${guid}`, {
              state: {selected: expireList.map(item => item.guid)},
            });
          }}
        >
          شارژ مجدد
        </button>
      </div>
    </div>
  );
};

export default ExpireNotification;
